import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, ModalBody, Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import insertlogo from '../../Assets/App_icon/insert.png';
import backlogo from '../../Assets/App_icon/back.png';

const DelmanMaster = () => {
  
  const store = localStorage.getItem('store');
  const host_url = localStorage.getItem('host_url');

  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false); 
  const [addmodalVisible, setAddModalVisible] = useState(false); 
  const [cashModalVisible, setCashModalVisible] = useState(false); 
  const [depoModalVisible, setDepoModalVisible] = useState(false); 
  const [returnModalVisible, setReturnModalVisible] = useState(false); 
  
  const [delmans, setDelmans] = useState([]);
  const [selectedDelman, setSelectedDelman] = useState([]);
  const [delLedger, setdelLedger] = useState([]);   
  const [cashDepoAmt, setCashDepoAmt] = useState('');
  const [cashAccList, setCashAccList] = useState('');
  const [cashAccId, setCashAccId] = useState('');
  const [returnList, setReturnList] = useState([]); 

  const [addDelmanMo, setAddDelmanMo] = useState('');
  const [addDelmanName, setAddDelmanName] = useState('');
  const [addDelmanAdd, setAddDelmanAdd] = useState('');
  const [addDelmanMo2, setAddDelmanMo2] = useState('');
  

  const handleBack = () => {
    navigate('../dashboard');
  };

    // Escape key press handling
    useEffect(() => {
      const handleKeyPress = (event) => {
        if (event.key === "Escape") {

          // Close modal or navigate back if no modal is open
          if (cashModalVisible || modalVisible || addmodalVisible || depoModalVisible || returnModalVisible ) {
              if(depoModalVisible){
                setDepoModalVisible(false);
              } else if(returnModalVisible){
                setReturnModalVisible(false);
              } else {
                setModalVisible(false);
                setAddModalVisible(false);
                setCashModalVisible(false);
              }
            
          } else {
            handleBack();
          }
        }
        
        if (event.key === "Insert" && !addmodalVisible) {
          setAddModalVisible(true);
        }
      };

      document.addEventListener("keydown", handleKeyPress);
      return () => {
        document.removeEventListener("keydown", handleKeyPress);
      };
    }, [modalVisible, addmodalVisible, cashModalVisible, depoModalVisible, returnModalVisible]);

    useEffect(() => { 
      const fetchUserList = async () => { 
          try {
            const response = await fetch(`${host_url}/delman`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                delId : '',
                delMo: '',
                delName: '',
                delAdd: '',
                delMo2: '',
                delStatus: '',
              }),
            });
            const data = await response.json();
            setDelmans(data);
          } catch (error) {
            console.error('Error fetching cities:', error);
          }
          
      }; 
     fetchUserList(); 
    }, []); // Delman List

    useEffect(() => {     
        const fetchAccountDetail = async () => { 
          const accountDetail = {
              acc_type: 'CashBank_Party',
          };
          try {
            const response = await fetch(`${host_url}/account_select`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                accDetail: accountDetail,
              }),
            });            
            const data = await response.json();
            setCashAccList(data);              
           
          } catch (error) {
            console.error('Error fetching categories:', error);
          }
        }; 

       if(depoModalVisible){
          fetchAccountDetail(); 
        }
    }, [depoModalVisible]); // Cash Party List

    useEffect(() => { 
        const fetchReturnList = async () => { 
          try {
            const response = await fetch(`${host_url}/del_return`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                store: store,
                del_id : selectedDelman.delId,
              }),
            });            
            const data = await response.json();
            setReturnList(data);   
            console.log(data);           
          } catch (error) {
            console.error('Error fetching categories:', error);
          }
        }; 
        if(returnModalVisible){
          fetchReturnList(); 
        } 
    }, [returnModalVisible]); // Return Item List

    const [delmanMoFilter, setDelmanMoFilter] = useState('');
    const [delmanNameFilter, setDelmanNameFilter] = useState('');
    const [delmanStatusFilter, setDelmanStatusFilter] = useState('');

    const filteredDelmans = delmans.filter(delmans =>
      String(delmans.delMo).toLowerCase().includes(delmanMoFilter.toLowerCase()) &&
      delmans.delName.toLowerCase().includes(delmanNameFilter.toLowerCase()) &&
      delmans.delStatus.toLowerCase().includes(delmanStatusFilter.toLowerCase())
    );

    const totalCount = filteredDelmans.length;
    const totalPending = filteredDelmans.reduce((sum, delmans) => sum + Number(delmans.ord_pending), 0);
    const totalReturn = filteredDelmans.reduce((sum, delmans) => sum + Number(delmans.item_return), 0);
    const totalBalance = filteredDelmans.reduce((sum, delmans) => sum + Number(delmans.delBalance), 0);

    const handleUserDetail = (user) => {
      setModalVisible(true);
      setSelectedDelman(user);
    };

    // Functions for handling the different actions
    const handleAddUser = async () => {
      setAddModalVisible(false);
      const delDetail = {
            delMo: addDelmanMo,
            delName: addDelmanName,
            delAdd: addDelmanAdd,
            delMo2: addDelmanMo2,
            delStatus: 'Y',
      };
      try {
        const response = await fetch(`${host_url}/delman`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'insert',
            store: store,
            delDetail: delDetail,
          }),
        });
        const data = await response.json();
        setDelmans(data);
        setAddDelmanMo('');
        setAddDelmanName('');
        setAddDelmanAdd('');
        setAddDelmanMo2('');
        
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    const handleUpdateUser = async () => {
      setModalVisible(false);
      const delDetail = {
            delId : selectedDelman.delId,
            delName: selectedDelman.delName,
            delMo: selectedDelman.delMo,
            delAdd: selectedDelman.delAdd,
            delMo2: selectedDelman.delMo2,
            delStatus: selectedDelman.delStatus,
      };
      try {
        const response = await fetch(`${host_url}/delman`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'update',
            store: store,
            delDetail: delDetail,
          }),
        });
        const data = await response.json();
        setDelmans(data);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    const handleDeleteUser = async () => {
      const userConfirmed = window.confirm('Are you sure you want to delete this Deliveryman?');
      if (userConfirmed) {
          setModalVisible(false);
          const delDetail = {
                delId : selectedDelman.delId,
          };
          try {
            const response = await fetch(`${host_url}/delman`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'delete',
                store: store,
                delDetail: delDetail,
              }),
            });
            const data = await response.json();
            if (data.message) {
                alert(data.message); 
            } else {
                setDelmans(data);
            }
            
          } catch (error) {
            console.error('Error fetching cities:', error);
          }
      }  
    };

    const handleCashLedger = async (row) => {
      setCashModalVisible(true);
      setSelectedDelman(row);
      setCashDepoAmt(row.delBalance);
      try {
        const response = await fetch(`${host_url}/del_balance`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            store: store,
            del_id : row.delId,
          }),
        });
        const data = await response.json();
        setdelLedger(data);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    const handleCashDeposite = async (row) => {
      setDepoModalVisible(false);
      setCashModalVisible(false);
      
      const today = new Date().toISOString().split("T")[0];
      const delDetail = {
            delId : selectedDelman.delId,
            acc_id : cashAccId,
            cash_Amt : cashDepoAmt,
            tr_date : today,
      };

      try {
        const response = await fetch(`${host_url}/delman`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'Cash_Deposite',
            store: store,
            delDetail: delDetail,
          }),
        });
        const data = await response.json();
        setDelmans(data);
        setCashAccId('');
        setCashDepoAmt('');
        
      } catch (error) {
        console.error('Error fetching cities:', error);
      }    
    };

    const handleReturnModal = async (row) => {
      setReturnModalVisible(true);
      setSelectedDelman(row);
    };

    const handleReturnItem = async () => {
      setReturnModalVisible(false);
      const delDetail = {
            delId : selectedDelman.delId,
      };

      try {
        const response = await fetch(`${host_url}/delman`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'Return_Item',
            store: store,
            delDetail: delDetail,
          }),
        });
        const data = await response.json();
        setDelmans(data);        
      } catch (error) {
        console.error('Error fetching cities:', error);
      }    
    };


  return (
    <div className="container">
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <div onClick={handleBack}>
                <img src={backlogo} alt="Back" className='system-icon'/>
              </div>
              <b style={{ margin: '10px', fontSize: '20px' }}>Deliveryman Master</b>
              <div onClick={() => setAddModalVisible(true)}>
                <img src={insertlogo} alt="Back" className='system-icon'/>
              </div>
          </div>
         
        
          <table className="table-bordered table-sm custom-hover">
            <thead>
              <tr >
                <th colSpan='2'>Name</th>
                <th>Mobile</th>  
                <th>Status</th>
                <th>Pending</th>
                <th>Return</th>
                <th>Cash</th>
              </tr>
              <tr>
                <th colSpan='2'>
                  <input
                    type="text"
                    className="search-input"
                    value={delmanNameFilter}
                    onChange={(e) => setDelmanNameFilter(e.target.value)}
                  />
                </th>
                <th>
                  <input
                    type="text"
                    className="search-input"
                    value={delmanMoFilter}
                    onChange={(e) => setDelmanMoFilter(e.target.value)}
                  />
                </th>
                <th>
                  <select
                    className="search-input"
                    value={delmanStatusFilter}
                    onChange={(e) => setDelmanStatusFilter(e.target.value)}
                  >
                    <option value="">All Status</option>
                    <option value="Y">Active</option>
                    <option value="N">Inactive</option>
                  </select>
                </th>
                <th>Order</th>
                <th>Items</th>
                <th>Balance</th>
              </tr>
            </thead>
            <tbody className="scrollable-body">
              {filteredDelmans.map((row) => {
                  return (
                    <tr key={row.delId} style={{ lineHeight: '10px' }} >
                      
                      <td colSpan='2' className="cell-left" onClick={() => handleUserDetail(row)} ><span style={{ paddingLeft: '10px' }}>{row.delName}</span></td>
                      <td onClick={() => handleUserDetail(row)} ><span style={{ paddingLeft: '10px' }}>{row.delMo}</span></td>
                      <td style={{cursor: 'default'}}>
                        <span style={{display: 'flex', paddingLeft: '10px'}}>
                          <span style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: row.delStatus === 'N' ? '#ff0000' : '#00962d', marginRight: '5px'}}></span>
                          <span>{row.delStatus === 'N' ? 'Inactive' : 'Active'}</span>
                        </span>
                      </td>
                      <td className="cell-right" style={{cursor: 'default'}}><span style={{ paddingRight: '10px' }}>{row.ord_pending}</span></td>
                      <td className="cell-right" onClick={() => handleReturnModal(row)} > <span style={{ paddingRight: '10px' }}>{row.item_return}</span></td>
                      <td className="cell-right" onClick={() => handleCashLedger(row)} ><span style={{ paddingRight: '10px' }} >{row.delBalance}</span></td>
                    </tr>
                  );
              })}
            </tbody>
            <tfoot>
              <tr >
                <th className="cell-left" colSpan='2'><span style={{ paddingLeft: '15px' }}>{totalCount}</span></th>
                <th className="cell-left" colSpan='2'><span style={{ paddingLeft: '10px' }}></span></th>
                <th className="cell-right"><span style={{ paddingRight: '10px' }}>{totalPending}</span></th>
                <th className="cell-right"><span style={{ paddingRight: '15px' }}>{totalReturn}</span></th>
                <th className="cell-right"><span style={{ paddingRight: '15px' }}>{totalBalance}</span></th>
              </tr>
            </tfoot>
          </table>
        
          {/* Modal for Deliveryman Detail */}
            <Modal isOpen={modalVisible}  className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >User Detail</h5>  
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%' }}>
                      <tr>
                        <td className="cell-left">Mobile No.</td>
                        <td><input type="text" maxLength="10" value={selectedDelman.delMo} onChange={(e) => setSelectedDelman({ ...selectedDelman, delMo: e.target.value.replace(/[^0-9]/g, '').slice(0, 10) })} /></td>
                      </tr>
                      <tr>
                        <td className="cell-left">Name</td>
                        <td><input type="text" value={selectedDelman.delName} onChange={(e) => setSelectedDelman({ ...selectedDelman, delName: e.target.value })} /></td>
                      </tr>
                      <tr>
                        <td className="cell-left">Address</td>
                        <td><input type="text" value={selectedDelman.delAdd} onChange={(e) => setSelectedDelman({ ...selectedDelman, delAdd: e.target.value })} /></td>
                      </tr>
                      <tr>
                        <td className="cell-left"> Ref Mo. No.</td>
                        <td><input type="text" maxLength="10" value={selectedDelman.delMo2} onChange={(e) => setSelectedDelman({ ...selectedDelman, delMo2: e.target.value.replace(/[^0-9]/g, '').slice(0, 10)})} /></td>
                      </tr>
                      <tr>
                        <td className="cell-left">Status</td>
                        <td><select
                              value={selectedDelman.delStatus}
                              onChange={(e) => setSelectedDelman({ ...selectedDelman, delStatus: e.target.value })}
                            >
                              <option value="Y">Active</option>
                              <option value="N">Inactive</option>
                            </select>
                        </td>                      
                      </tr>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button color="danger" style={{ flex: 1, marginRight: '10px' }} onClick={handleDeleteUser}>
                      Delete
                    </Button>
                    <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={handleUpdateUser}>
                      Update
                    </Button>
                    <Button color="primary" style={{ flex: 1 }} onClick={() => setModalVisible(false)}>
                      Close
                    </Button>
                  </div>
                
              </ModalBody>
            </Modal>

          {/* Modal for Add New Deliveryman */}
            <Modal isOpen={addmodalVisible}  className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >Add New User</h5>  
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%' }}>
                      <tr>
                        <td className="cell-left">Mobile No.</td>
                        <td><input type="text" maxLength="10" value={addDelmanMo} onChange={(e) => setAddDelmanMo(e.target.value.replace(/[^0-9]/g, '').slice(0, 10))}/></td>
                      </tr>
                      <tr>
                        <td className="cell-left">Name</td>
                        <td><input type="text" value={addDelmanName} onChange={(e) => setAddDelmanName(e.target.value)} /></td>
                      </tr>
                      <tr>
                        <td className="cell-left">Address</td>
                        <td><input type="text" value={addDelmanAdd} onChange={(e) => setAddDelmanAdd(e.target.value)} /></td>
                      </tr>
                      <tr>
                        <td className="cell-left"> Ref Mo. No.</td>
                        <td><input type="text" maxLength="10" value={addDelmanMo2} onChange={(e) => setAddDelmanMo2(e.target.value.replace(/[^0-9]/g, '').slice(0, 10))} /></td>
                      </tr>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={handleAddUser}>
                      Add New
                    </Button>
                    <Button color="primary" style={{ flex: 1 }} onClick={() => setAddModalVisible(false)}>
                      Close
                    </Button>
                  </div>
                
              </ModalBody>
            </Modal>  

          {/* Modal for Cash Ledger Detail */}
            <Modal isOpen={cashModalVisible} className="detailmodal-lg" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >{selectedDelman.delName}</h5>  
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '58%', marginRight: '2%', border: '2px solid #dcdcdc'}}>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th className="cell-left" style={{ padding: '2px' }} >Date</th>
                          <th colSpan='3' className="cell-left" style={{ padding: '2px' }} >Name</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px', }} >Amount</th>
                        </tr>
                      </thead>

                      <tbody className="scrollable-body">
                        {delLedger.map((row, index) => {
                          if (row.dcl_date !== null) {
                            return (
                              <tr key={index} style={{ cursor: 'pointer' }}>
                                <td className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}>
                                  {new Date(row.dcl_date).toLocaleDateString("en-GB").replace(/\//g, "-")}
                                </td>
                                <td colSpan='3' className="cell-left" style={{ padding: '2px', fontSize: '14px' }}>
                                  {row.dcl_cust_name} ({row.dcl_cust_id})
                                </td>
                                <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }}>
                                  {row.dcl_cash_amt}
                                </td>
                              </tr>
                            );
                          }
                          return null; 
                        })}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th className="cell-left"style={{ padding: '2px' }} >{delLedger.length}</th>
                          <th colSpan='3' className="cell-left" style={{ padding: '2px' }} ></th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >{delLedger.reduce((sum, ledger) => sum + (Number(ledger.dcl_cash_amt) || 0), 0)}</th>
                        </tr> 
                      </tfoot>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '40%', border: '2px solid #dcdcdc'}}>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <tbody>
                        <tr>
                          <td className="cell-left">Op Balance :</td>
                          <td className="cell-right">{(selectedDelman.delBalance) - delLedger.reduce((sum, ledger) => sum + (Number(ledger.dcl_cash_amt) || 0), 0)}</td>
                        </tr>
                        <tr>
                          <td className="cell-left">Collection :</td>
                          <td className="cell-right">{delLedger.reduce((sum, ledger) => sum + (Number(ledger.dcl_cash_amt) || 0), 0)}</td>
                        </tr>
                        <tr>
                          <th className="cell-left" style={{ paddingLeft: '5px' }}>Balance :</th>
                          <th className="cell-right" style={{ paddingRight: '5px' }}>{selectedDelman.delBalance}</th>
                        </tr>
                        <tr>

                          <td colSpan='2'>
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', margin: '0 auto' }}>
                            <Button color="success" style={{ flex: 1, marginLeft: '10px', marginRight: '10px' }} onClick={() => setDepoModalVisible(true)}>
                              Cash Deposit 
                            </Button>
                            <Button color="primary" style={{ flex: 1, marginRight: '10px' }} onClick={() => setCashModalVisible(false)}>
                              Close
                            </Button>
                          </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </ModalBody>
            </Modal>  
          
          {/* Modal for Cash Deposite */}
            <Modal isOpen={depoModalVisible}  className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >Cash Deposite</h5>  
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%' }}>
                      <tr>
                        <td className="cell-left">Amount</td>
                        <td><input type="text" maxLength="10" value={cashDepoAmt} onChange={(e) => setCashDepoAmt(e.target.value.replace(/[^0-9]/g, ''))}/></td>
                      </tr>
                      <tr>
                        <td className="cell-left">Cash Acount</td>
                        <td>
                            {cashAccList && (
                              <select
                                value={cashAccId}
                                onChange={(e) => setCashAccId(e.target.value)}
                              >
                                <option key='' value=''>Select Party</option>
                                {cashAccList.map((accList, index) => (
                                    <option key={index} value={accList.sacc_id}>
                                      {accList.sacc_name}
                                    </option>
                                ))}
                              </select>
                            )}
                        </td>                      
                      </tr>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    
                    <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={handleCashDeposite} disabled={!cashAccId || !cashDepoAmt}>
                      Diposite
                    </Button>
                    <Button color="primary" style={{ flex: 1 }} onClick={() => setDepoModalVisible(false)}>
                      Close
                    </Button>
                  </div>
                
              </ModalBody>
            </Modal>

          {/* Modal for Return Item */}
            <Modal isOpen={returnModalVisible}  className="detailmodal-lg" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >Return Item</h5>  
                  <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr>
                        <th colSpan='3' className="cell-left" style={{ padding: '2px' }} >Customer</th>
                        <th colSpan='2' className="cell-left" style={{ padding: '2px' }} >Item</th>
                        <th className="cell-right" style={{ padding: '2px', paddingRight: '10px', }} >Unit</th>
                      </tr>
                    </thead>
                    <tbody className="scrollable-body">
                      {returnList.map((row, index) => {
                          return (
                            <tr key={index} style={{ cursor: 'pointer' }} >
                              <td colSpan='3'className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}>{row.cust_name} ({row.cust_id})</td>
                              <td colSpan='2'className="cell-left" style={{ padding: '2px', fontSize: '14px' }} >{row.dcl_cust_name} {row.prd_name}</td>
                              <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{row.prd_unit}</td>
                            </tr>
                          );
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <th colSpan='3' className="cell-left"style={{ padding: '2px' }} >Total Item</th>
                        <th colSpan='2' className="cell-left" style={{ padding: '2px' }} >{returnList.length}</th>
                        <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} ></th>
                      </tr> 
                    </tfoot>
                  </table>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '50%', margin: '0 auto' }}>
                    <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={handleReturnItem} disabled={returnList.length < 1}>
                      Collect
                    </Button>
                    <Button color="primary" style={{ flex: 1 }} onClick={() => setReturnModalVisible(false)}>
                      Close
                    </Button>
                  </div>
                
              </ModalBody>
            </Modal>  
    </div>
  );
};

export default DelmanMaster;
